import { Navigate } from 'react-router-dom'
import ROUTES from '../../../assets/routes'
import { Box } from '@mui/material'
import { isAuthenticated } from '../../../util/authentication'
import PinSessionUnlockGate from './PinSessionUnlockGate'

const ProtectedRoute = ({ children }: any) => {
    let authenticated: boolean = isAuthenticated()

    if (!authenticated) {
        return <Navigate to={ROUTES.login} replace />
    }

    return (
        <PinSessionUnlockGate>
            <Box sx={{ width: '100%', height: '100%' }}>{children}</Box>
        </PinSessionUnlockGate>
    )
}

export default ProtectedRoute